export const LEADS_LITERALS = {
    accountCreationFailed: 'error_leads_account_creation_failed',
    accountsCreated: 'label_leads_accounts_created',
    anyBusinessType: 'label_leads_any_business_type',
    backToAccounts: 'action_leads_back_to_accounts',
    backToProspectingResults: 'action_leads_back_to_prospecting_results',
    businessType: 'label_leads_business_type',
    businessTypeFood: 'label_leads_business_type_food_beverage',
    businessTypeHealthcare: 'label_leads_business_type_healthcare',
    businessTypeHvac: 'label_leads_business_type_hvac_facilities',
    businessTypeManufacturing: 'label_leads_business_type_manufacturing',
    businessTypeProfessional: 'label_leads_business_type_professional_services',
    businessTypeRetail: 'label_leads_business_type_retail',
    confirmAndEnhance: 'action_leads_confirm_and_enhance',
    company: 'label_leads_company',
    createRemaining: 'action_leads_create_remaining',
    createRemainingAccounts: 'title_leads_create_remaining_accounts',
    createRemainingDescription: 'label_leads_create_remaining_description',
    createRemainingTooltip: 'label_leads_create_remaining_tooltip',
    created: 'label_leads_created',
    createdRecordsTip: 'label_leads_created_records_tip',
    creatingAccounts: 'label_leads_creating_accounts',
    currentBalance: 'label_leads_current_balance',
    distanceFromOrigin: 'label_leads_distance_from_origin',
    dragPinHelp: 'label_leads_drag_pin_help',
    enhanceSelected: 'action_leads_enhance_selected',
    enhancementFailed: 'error_leads_enhancement_failed',
    enhancementFailedStatus: 'label_leads_enhancement_failed_status',
    enhancementProgress: 'label_leads_enhancement_progress',
    enhancementSubmitted: 'label_leads_enhancement_submitted',
    failed: 'label_leads_failed',
    failedNotCharged: 'label_leads_failed_not_charged',
    fields: 'label_leads_fields',
    finishProcess: 'action_leads_finish_process',
    insufficientCredits: 'error_leads_insufficient_credits',
    leadName: 'label_leads_lead_name',
    mapProspectingComplete: 'title_leads_map_prospecting_complete',
    maxCost: 'label_leads_max_cost',
    maxResults: 'label_leads_max_results',
    new: 'label_leads_new',
    noCoordinatesReturned: 'error_leads_no_coordinates_returned',
    openMapProspectingTooltip: 'tooltip_leads_map_prospecting',
    pending: 'label_leads_pending',
    placeSearchPlaceholder: 'placeholder_leads_search_place',
    potentialDuplicate: 'label_leads_potential_duplicate',
    potentialDuplicates: 'label_leads_potential_duplicates',
    previewFailed: 'error_leads_preview_failed',
    previewIsFree: 'label_leads_preview_is_free',
    projectedBalance: 'label_leads_projected_balance',
    prospectFromMap: 'action_leads_prospect_from_map',
    radius: 'label_leads_radius',
    reviewAndCreate: 'action_leads_review_and_create',
    reviewEnrichedLeads: 'title_leads_review_enriched_leads',
    runProspecting: 'action_leads_run_prospecting',
    searchOrigin: 'label_leads_search_origin',
    selected: 'label_leads_selected',
    selectedLeads: 'label_leads_selected_leads',
    showPotentialDuplicates: 'label_leads_show_potential_duplicates',
    status: 'label_leads_status',
    successful: 'label_leads_successful',
    matchQuality: 'label_leads_match_quality',
    rowAction: 'label_leads_row_action',
    tourDescription: 'label_leads_tour_description',
    useCredits: 'title_leads_use_credits',
    useCreditsDescription: 'label_leads_use_credits_description',
    useCreditsMarkdown: 'label_leads_use_credits_markdown',
    validOriginRequired: 'error_leads_valid_origin_required',
};

const WORD_OVERRIDES = {
    cta: 'CTA',
    hvac: 'HVAC',
};

const SENTENCE_OVERRIDES = {
    [LEADS_LITERALS.accountCreationFailed]: 'We could not create this account.',
    [LEADS_LITERALS.backToProspectingResults]: 'Back to prospecting results',
    [LEADS_LITERALS.businessTypeFood]: 'Food & beverage',
    [LEADS_LITERALS.businessTypeHvac]: 'HVAC & facilities',
    [LEADS_LITERALS.businessTypeProfessional]: 'Professional services',
    [LEADS_LITERALS.createRemainingDescription]: 'Create the remaining pending leads as accounts:',
    [LEADS_LITERALS.createRemainingTooltip]:
        'Creates every pending company with no form edits. Same creation date as individual saves.',
    [LEADS_LITERALS.createdRecordsTip]:
        'Review each enriched lead before creating the remaining accounts in bulk if needed.',
    [LEADS_LITERALS.dragPinHelp]: 'Drag the pin to change the search origin.',
    [LEADS_LITERALS.enhancementFailed]: 'We could not enhance the selected leads.',
    [LEADS_LITERALS.failedNotCharged]: 'Failed leads were not charged.',
    [LEADS_LITERALS.insufficientCredits]: 'You do not have enough credits for the selected leads.',
    [LEADS_LITERALS.noCoordinatesReturned]: 'No valid coordinates were returned for this search.',
    [LEADS_LITERALS.openMapProspectingTooltip]:
        'Find nearby businesses on the map, enrich them, and create accounts.',
    [LEADS_LITERALS.placeSearchPlaceholder]: 'Search a place or address',
    [LEADS_LITERALS.previewFailed]: 'We could not load the preview.',
    [LEADS_LITERALS.previewIsFree]:
        'Preview is free. Credits are only used when you enhance leads.',
    [LEADS_LITERALS.tourDescription]:
        'Find nearby businesses on the map, enrich them, and create accounts faster.',
    [LEADS_LITERALS.useCreditsDescription]:
        'Enhancing selected leads uses credits from your current balance.',
    [LEADS_LITERALS.useCreditsMarkdown]:
        'You currently have **%1$s** credits.\n\nEnhancing **%2$s** selected leads will use **%3$s** credits and leave **%4$s** credits.',
    [LEADS_LITERALS.validOriginRequired]: 'Select a valid origin before running prospecting.',
};

const splitCamelCase = (value = '') =>
    value
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .split(' ')
        .filter(Boolean);

const humanizeWord = (word = '') => WORD_OVERRIDES[word] || word.toLowerCase();

const buildDebugLabel = (specKey) => {
    const words = splitCamelCase(specKey);
    if (!words.length) return specKey;

    return words
        .map((word, index) => {
            const normalizedWord = humanizeWord(word);
            if (!normalizedWord) return normalizedWord;
            if (normalizedWord === normalizedWord.toUpperCase()) return normalizedWord;
            if (index === 0) {
                return normalizedWord.charAt(0).toUpperCase() + normalizedWord.slice(1);
            }
            return normalizedWord;
        })
        .join(' ');
};

export const LEADS_DEBUG_LITERALS = Object.fromEntries(
    Object.entries(LEADS_LITERALS).map(([specKey, literalKey]) => [
        literalKey,
        SENTENCE_OVERRIDES[literalKey] || buildDebugLabel(specKey),
    ]),
);
